import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"
import _imports_0 from '../assets/img/payment-methods.png'
import _imports_1 from '../assets/img/leasity-powered-by.svg'


const _hoisted_1 = { class: "px-9 sm:px-14 md:px-32 xl:px-56 py-9 md:py-20 flex-col-grow" }
const _hoisted_2 = { class: "py-8 flex-col-grow" }
const _hoisted_3 = {
  key: 0,
  class: "flex-col-grow items-center"
}
const _hoisted_4 = { class: "w-full" }
const _hoisted_5 = { class: "my-6 lg:my-3 flex justify-between" }
const _hoisted_6 = { class: "w-full my-1 lg:my-6 flex-col-grow lg:flex-row 2xl:pb-20 items-center justify-center" }
const _hoisted_7 = { class: "flex items-center w-72 flex-col bg-white rounded-md shadow-md" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CreditorInfo = _resolveComponent("CreditorInfo")!
  const _component_VoucherCard = _resolveComponent("VoucherCard")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _cache[8] || (_cache[8] = _createElementVNode("div", { class: "bg-image brand-img" }, null, -1)),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_Transition, {
          name: "fade",
          onAfterLeave: _ctx.afterTransition,
          appear: ""
        }, {
          default: _withCtx(() => [
            (_ctx.show)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _cache[6] || (_cache[6] = _createElementVNode("h1", { class: "text-center font-medium text-2xl text-base-color-alt" }, " Pago Express ", -1)),
                    _createElementVNode("div", _hoisted_5, [
                      _createVNode(_component_CreditorInfo, {
                        "creditor-name": _ctx.creditorName,
                        "creditor-tax-id": _ctx.creditorTaxId
                      }, null, 8, ["creditor-name", "creditor-tax-id"]),
                      (_ctx.voucherService.hasMultipleVouchers())
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            class: "ml-3 font-medium text-base-color",
                            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.nextVoucher && _ctx.nextVoucher(...args)))
                          }, " Voucher Siguiente "))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_VoucherCard, {
                      voucher: _ctx.voucher,
                      onPayVoucher: _ctx.showPaymentMethodsModal
                    }, null, 8, ["voucher", "onPayVoucher"]),
                    _cache[7] || (_cache[7] = _createElementVNode("div", { class: "my-12 sm:my-20 lg:my-0 lg:ml-20 xl:ml-24 2xl:ml-36" }, [
                      _createElementVNode("h1", { class: "hidden lg:block mx-auto mb-1 font-medium text-2xl text-center tracking-tight text-base-color-alt" }, " Resumen "),
                      _createElementVNode("p", { class: "mx-auto w-60 sm:w-full lg:w-52 text-center text-gray-4" }, " Revisa los vouchers y selecciona tu medio de pago. "),
                      _createElementVNode("img", {
                        class: "mx-auto my-5",
                        width: "267",
                        src: _imports_0
                      }),
                      _createElementVNode("a", { href: "https://www.leasity.cl" }, [
                        _createElementVNode("img", {
                          class: "mx-auto w-40 h-7 lg:h-9",
                          src: _imports_1
                        })
                      ])
                    ], -1))
                  ])
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["onAfterLeave"])
      ])
    ]),
    _cache[11] || (_cache[11] = _createElementVNode("div", { class: "hidden w-full h-16 bg-gray-1 brand-banner" }, null, -1)),
    (_ctx.showPaymentModal)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "fixed w-screen h-screen bg-gray-1 opacity-20",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.hidePaymentMethodsModal && _ctx.hidePaymentMethodsModal(...args)))
        }))
      : _createCommentVNode("", true),
    (_ctx.showPaymentModal)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "fixed flex justify-center items-center w-screen h-screen",
          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.hidePaymentMethodsModal && _ctx.hidePaymentMethodsModal(...args)))
        }, [
          _createElementVNode("div", _hoisted_7, [
            _cache[9] || (_cache[9] = _createElementVNode("p", { class: "text-lg mt-3" }, "Selecciona tu método de pago", -1)),
            _createElementVNode("img", {
              class: "w-9/12 mt-3 mb-5 cursor-pointer",
              src: "https://www.leasity.cl/assets/img/brands/servipag.png",
              width: "200px",
              alt: "Servipag",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.payVoucher('servipag')))
            }),
            _createElementVNode("img", {
              class: "w-9/12 cursor-pointer",
              src: "https://s3.amazonaws.com/static.khipu.com/buttons/2021/200x75-white.png",
              width: "200px",
              alt: "Khipu",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.payVoucher('khipu')))
            }),
            _createElementVNode("img", {
              class: "w-7/12 cursor-pointer",
              src: "https://www.leasity.cl/assets/img/brands/otp.svg",
              width: "200px",
              alt: "Otros Pagos",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.payVoucher('otp')))
            }),
            _cache[10] || (_cache[10] = _createElementVNode("a", {
              class: "text-center text-gray-2 mt-2 mb-4",
              href: "https://www.leasity.cl/assets/documents/guia_de_pagos.pdf",
              target: "_blank"
            }, [
              _createTextVNode("¿No sabes cuál escoger?"),
              _createElementVNode("br"),
              _createTextVNode("Revisa nuestra guía de pagos")
            ], -1))
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}